export const allowedRemoteSources = {
  youtube: 'video/vnd.youtube.yt',
};

export default allowedRemoteSources;
